import React, { useEffect, useRef, useState } from "react";
import useFetchData from "../../../hooks/useFetchData";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import { useTableContext } from "../../../context/TableContext";
import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";
import TableTreeModal from "../../../components/BuilderComponents/TableTreeModal";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";

const CartVariableMapping = ({ cartMapping, onChange, cartId, subformId }) => {
  // const smId = editFieldData.import_cart;
  // const subFormId = editFieldData.sub_form;
  const [fetchUrl, setFetchUrl] = useState(null);
  const [mappingFields, setMappingFields] = useState([]);
  const fieldsData = useRef({});
  const [isModalOpen, setIsModalOpen] = useState(null);
  const { getTableTypeData } = useTableContext();
  useEffect(() => {
    if (subformId) {
      setFetchUrl(`subform/${subformId}`);
    }
  }, [subformId]);

  const { data, loading, error } = useFetchData(fetchUrl);

  const getFieldsOfTable = async () => {
    try {
      const { tableObject } = await getTableTypeData("entity", cartId);
      fieldsData.current = tableObject;
    } catch (error) {
      console.log(error);
    }
  };

  const createMappingFromData = async () => {
    const allSubformFields = data.config.fields || [];
    await getFieldsOfTable();
    const vmData = {};
    for (const field of cartMapping) {
      vmData[field.key] = field;
    }
    const keyValue = allSubformFields.map((field) => {
      fieldsData.current[field.id] = field;
      if (vmData[field.id]) {
        if (
          vmData[field.id].type === "cart_quantity" ||
          vmData[field.id].type === "cart_lookup" ||
          fieldsData.current[vmData[field.id].value]
        ) {
          return vmData[field.id];
        }
      }
      return {
        key: field.id,
        value: "",
        type: "mapped"
      };
    });
    setMappingFields(keyValue);
  };

  const handleChangeField = (data) => {
    const copyOfFields = [...mappingFields];
    copyOfFields[isModalOpen].value = data.id;
    setMappingFields(copyOfFields);
    setIsModalOpen(null);
  };

  const handleDeleteField = (e, index) => {
    e.stopPropagation();
    const copyOfFields = [...mappingFields];
    copyOfFields[index].value = "";
    setMappingFields(copyOfFields);
  };

  const handleChangeType = (type, index) => {
    const copyOfFields = [...mappingFields];
    copyOfFields[index].type = type;
    setMappingFields(copyOfFields);
  };

  const updateActualMappingOfField = () => {
    const newMappingData = mappingFields.filter(
      (field) =>
        field.value || fieldsData.current[field.value] || field.type === "cart_quantity" || field.type === "cart_lookup"
    );
    // const newEditFieldData = [ ...editFieldData };
    // newEditFieldData.cart_mapping = newMappingData;
    onChange(newMappingData);
  };

  useEffect(() => {
    if (data && cartId) {
      createMappingFromData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, cartId]);

  useEffect(() => {
    if (data) {
      updateActualMappingOfField();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mappingFields]);
  if (!cartId || !subformId) {
    return null;
    // return <div className="">Select Cart and Subform</div>;
  }
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Not Able to fetch data</div>;
  }

  const typeSelections = (type, index) => {
    const typeOptions = [
      { id: "mapped", name: "Mapped" },
      { id: "cart_quantity", name: "Quantity" },
      { id: "cart_lookup", name: "Cart Item" }
    ];

    return (
      <SingleSelectBox
        selectedData={type}
        options={typeOptions}
        onChange={(obj) => handleChangeType(obj.id, index)}
        placeholder="Select Type"
      />
    );
  };

  const getBodyOfTable = () => {
    return mappingFields.map((field, index) => {
      return (
        <tr key={field.key}>
          <td className="border_full">{fieldsData.current[field.key].label}</td>
          <td className="border_full">{typeSelections(field.type, index)}</td>
          {/* <td>{field.type}</td> */}
          {field.type === "mapped" ? (
            <td className="border_full" onClick={() => setIsModalOpen(index)}>
              <div className="builder_input">
                {fieldsData.current[field.value] ? (
                  <div style={{ display: "flex" }}>
                    <span>{fieldsData.current[field.value].display}</span>
                    <ButtonActionIcon size="xsm" type="delete" onClick={(e) => handleDeleteField(e, index)} />
                  </div>
                ) : (
                  "Select Field"
                )}
              </div>
            </td>
          ) : (
            <td>
              <div className="text_center builder_input">---</div>
            </td>
          )}
        </tr>
      );
    });
  };

  return (
    <div>
      <label className="builder_label">Variable Mapping</label>
      <table>
        <thead>
          <tr>
            <th className="border_full">Fields</th>
            <th className="border_full">Type</th>
            <th className="border_full">Value</th>
          </tr>
        </thead>
        <tbody style={{ backgroundColor: "white", fontSize: "12px" }}>{getBodyOfTable()}</tbody>
      </table>
      <BuilderModal
        isOpen={isModalOpen === 0 || isModalOpen}
        onClose={() => setIsModalOpen(null)}
        modalName="Select Field"
      >
        <TableTreeModal
          tableId={cartId}
          callbackFunction={handleChangeField}
          selectedFile={mappingFields?.[isModalOpen]?.value || ""}
        />
      </BuilderModal>
    </div>
  );
};

export default CartVariableMapping;
